import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const HeadphonesOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12.01 3c-4.94 0-8.96 4.42-8.96 9.85v4.08c0 2.07 1.68 3.75 3.75 3.75 1.31 0 2.38-1.07 2.38-2.38v-3.43c0-1.31-1.07-2.38-2.38-2.38-.8 0-1.54.26-2.15.68v-.31c0-4.55 3.31-8.25 7.37-8.25 4.06 0 7.37 3.7 7.37 8.25v.31c-.61-.43-1.35-.68-2.15-.68-1.31 0-2.38 1.07-2.38 2.38v3.43c0 1.31 1.07 2.38 2.38 2.38 2.07 0 3.75-1.68 3.75-3.75v-4.08c0-5.43-4.02-9.85-8.97-9.85h-.01ZM6.79 14.08c.43 0 .78.35.78.78v3.43c0 .43-.35.78-.78.78-1.18 0-2.15-.96-2.15-2.15v-.7c0-1.18.96-2.15 2.15-2.15v.01Zm12.59 2.85c0 1.18-.96 2.15-2.15 2.15-.43 0-.78-.35-.78-.78v-3.43c0-.43.35-.78.78-.78 1.18 0 2.15.96 2.15 2.15v.7-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default HeadphonesOutlined
